export const BUSINESS = {
  name: "Yavapai Waste Solutions",
  short: "YWS",
  phone: "(928) 713-2710",
  phoneHref: "tel:+19287132710",
  email: "sales@ywsaz.com",
  address: "Prescott, Arizona",
  hours: "Monday–Friday · 8:00 AM – 5:00 PM",
  facebook: "https://www.facebook.com/yavapaiwastesolutions/",
  instagram: "https://www.instagram.com/yavapaiwastesolutions/",
  googleReviews: "https://www.google.com/search?q=yavapai%20waste%20solutions%20reviews&source=sh/x/gs/m2/5&shem=aimgspe,#ebo=1",
  logoLight: "/assets/yws/logo-transparent.png",
  logoDark: "/assets/yws/untitled-design.png",
  bookingUrl: "https://app.trashlab.com/shop-v3/0170d657-56c3-45a0-98c8-00f9dd3d113d",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Roll-Off Dumpsters", to: "/roll-off-dumpsters" },
  {
    label: "Front-Load Service",
    to: "/front-load",
    children: [
      { label: "Residential Front-Load", to: "/front-load/residential" },
      { label: "Commercial Front-Load", to: "/front-load/commercial" },
    ],
  },
  { label: "Contractors", to: "/contractor-dumpster-rentals" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Resources", to: "/resources" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const ROLLOFF_SIZES = [
  {
    size: "20",
    label: "20 Yard",
    capacity: "≈ 6 pickup loads",
    description: "The all-rounder. Our most versatile size for most projects.",
    uses: ["Kitchen remodels", "Roof replacements", "Deck removal"],
    popular: true,
    image: "/assets/yws/uploads/rolloff-20yard.jpg",
    imageAlt: "YWS 20-yard roll-off dumpster with Yavapai Waste Solutions branding",
    specs: {
      dimensions: "22'9\" L × 8'3\" W × 4'4\" H",
      capacity: ["120 32-gallon trash bags", "300 32-gallon recycling bins", "8 standard pickup truck loads", "Weight capacity of 4–5 tons"],
      idealFor: ["Yard debris — tree limbs, shrubs, grass clippings", "Drywall, ceilings, flooring & cabinetry", "Dirt and rocks", "Roofing and shingles", "Indoor & outdoor cleanouts", "Small remodel projects", "Junk removal"],
    },
  },
  {
    size: "30",
    label: "30 Yard",
    capacity: "≈ 9 pickup loads",
    description: "The builder's choice. Keeps busy job sites clear.",
    uses: ["New construction", "Major additions", "Whole-home renovations"],
    image: "/assets/yws/uploads/rolloff-30yard.jpg",
    imageAlt: "YWS 30-yard roll-off dumpster with Yavapai Waste Solutions branding",
    specs: {
      dimensions: "23'1\" L × 8'3\" W × 6'1\" H",
      capacity: ["180 32-gallon trash bags", "450 32-gallon recycling bins", "12 standard pickup truck loads", "Weight capacity of 6–7 tons"],
      idealFor: ["Bulkier junk items — furniture & appliances", "Drywall, plaster, flooring & wood", "Tree limbs", "Mid-sized remodels", "Mid-sized house & yard cleanouts", "Light demolition"],
    },
  },
  {
    size: "40",
    label: "40 Yard",
    capacity: "≈ 12 pickup loads",
    description: "Maximum capacity for the biggest jobs.",
    uses: ["Large-scale construction", "Demolition", "Commercial cleanouts"],
    image: "/assets/yws/uploads/rolloff-40yard.jpg",
    imageAlt: "YWS 40-yard roll-off dumpster with Yavapai Waste Solutions branding",
    specs: {
      dimensions: "23'1\" L × 8'3\" W × 7'9\" H",
      capacity: ["240 32-gallon trash bags", "600 32-gallon recycling bins", "16 standard pickup truck loads", "Weight capacity of 8–9 tons"],
      idealFor: ["Drywall, plaster, flooring & wood", "Large building cleanouts", "Large outdoor cleanups — including large tree limbs", "Large remodels & construction projects", "Bulk materials"],
    },
  },
];

export const FRONTLOAD_SIZES = [
  {
    size: "3",
    label: "3 Yard",
    capacity: "Compact",
    description: "Compact design provides extra capacity while still fitting in tight spaces and enclosures.",
    specs: {
      dimensions: "6' L × 4' W × 4' H",
      capacity: ["18 standard 30-gallon trash bags or recycling bins"],
      idealFor: ["Small to medium-sized businesses with up to 50 employees"],
    },
  },
  {
    size: "4",
    label: "4 Yard",
    capacity: "Mid-size",
    description: "Compact design fits in tight spaces and enclosures.",
    specs: {
      dimensions: "6' L × 4'2\" W × 4' H",
      capacity: ["24 standard trash bags or recycling bins"],
      idealFor: ["Small businesses with fewer than 100 employees"],
    },
  },
  {
    size: "6",
    label: "6 Yard",
    capacity: "High capacity",
    description: "Our 6-yard dumpster is ideal for mid-sized businesses.",
    specs: {
      dimensions: "6' L × 5'7\" W × 5'8\" H",
      capacity: ["36 standard trash bags or recycling bins"],
      idealFor: ["Medium businesses with 100–250 employees"],
    },
  },
  {
    size: "8",
    label: "8 Yard",
    capacity: "Maximum",
    description: "Our 8-yard dumpster is ideal for large businesses.",
    specs: {
      dimensions: "6' L × 6'8\" W × 6'2\" H",
      capacity: ["48 standard trash bags or recycling bins"],
      idealFor: ["Large businesses with 500 employees"],
    },
  },
];

export const SERVICE_AREAS = [
  {
    slug: "prescott",
    name: "Prescott",
    tagline: "The county seat — historic homes, active remodels, and a thriving downtown.",
    local: "From historic downtown renovations to new builds on the outskirts, Prescott keeps our roll-off trucks busy. We deliver all three roll-off sizes throughout the city — from Whiskey Row remodels to cleanouts in the pines — and provide residential and commercial front-load service for local properties and businesses.",
    projects: ["Historic home remodels", "Estate cleanouts", "Downtown business waste service"],
    nearby: ["prescott-valley", "williamson-valley", "chino-valley"],
  },
  {
    slug: "prescott-valley",
    name: "Prescott Valley",
    tagline: "One of Arizona's fastest-growing towns — new construction everywhere.",
    local: "Prescott Valley's growth means constant construction, and contractors here need a dumpster partner that keeps up. We support job sites across Prescott Valley with long-term roll-off rentals, Same-Day Swaps Available, and front-load service for the town's expanding retail and commercial corridors.",
    projects: ["New home construction", "Retail build-outs", "Subdivision development"],
    nearby: ["prescott", "dewey", "chino-valley"],
  },
  {
    slug: "chino-valley",
    name: "Chino Valley",
    tagline: "Rural lots, ranches, and room to build.",
    local: "Chino Valley's larger lots and rural properties generate serious cleanup projects — from firewise clearing to barn and property cleanouts. We deliver roll-off dumpsters throughout Chino Valley and offer front-load service for local businesses along Highway 89.",
    projects: ["Property & ranch cleanouts", "Firewise clearing", "New rural construction"],
    nearby: ["paulden", "prescott", "williamson-valley"],
  },
  {
    slug: "paulden",
    name: "Paulden",
    tagline: "Acreage properties and rural living north of Chino Valley.",
    local: "Paulden properties come with space — and space comes with cleanup projects. We bring roll-off dumpsters to Paulden for property cleanups, firewise defensible space work, and new construction, with no maximum rental period so you can work at your own pace.",
    projects: ["Acreage cleanups", "Defensible space clearing", "Home construction"],
    nearby: ["chino-valley", "williamson-valley", "prescott"],
  },
  {
    slug: "williamson-valley",
    name: "Williamson Valley",
    tagline: "Custom homes, horse properties, and wide-open acreage.",
    local: "Williamson Valley's custom home sites and horse properties need a dumpster company willing to come to them. We deliver roll-off dumpsters throughout Williamson Valley for new construction, remodels, and property cleanouts — and we keep rentals flexible for long projects.",
    projects: ["Custom home construction", "Horse property cleanouts", "Major remodels"],
    nearby: ["prescott", "paulden", "chino-valley"],
  },
  {
    slug: "dewey",
    name: "Dewey",
    tagline: "Established neighborhoods with steady renovation work.",
    local: "Dewey's established homes mean steady renovation, roofing, and cleanout work — exactly what our 20 and 30 yard roll-offs are built for. We serve Dewey homeowners and contractors with reliable delivery and Same-Day Swaps Available for existing rental customers.",
    projects: ["Home renovations", "Roof replacements", "Estate cleanouts"],
    nearby: ["humboldt", "prescott-valley", "prescott"],
  },
  {
    slug: "humboldt",
    name: "Humboldt",
    tagline: "Residential projects and small business service along Highway 69.",
    local: "From home remodels to business waste service along the Highway 69 corridor, Humboldt counts on YWS for dependable roll-off rentals and front-load service. Real people answer the phone — call us and see the difference.",
    projects: ["Residential remodels", "Small business front-load", "Property cleanouts"],
    nearby: ["dewey", "prescott-valley", "cordes-junction"],
  },
  {
    slug: "cordes-junction",
    name: "Cordes Junction",
    tagline: "Southern Yavapai County along the I-17 corridor.",
    local: "Cordes Junction sits at the southern edge of our service area, and we're proud to serve it. We deliver roll-off dumpsters for property cleanups and construction projects along the I-17 corridor — with the same straightforward pricing and reliable service as everywhere else we serve.",
    projects: ["Rural property cleanups", "Construction projects", "Storm & fire debris cleanup"],
    nearby: ["humboldt", "dewey", "prescott-valley"],
  },
];

export const TRUST_ITEMS = [
  "Locally Owned & Operated",
  "Veteran Owned",
  "Same-Day Swaps Available",
  "Saturday Swaps Available",
  "No Hidden Fees",
];

export const OLD_URL_REDIRECTS = {
  "/roll-off-dumpster": "/roll-off-dumpsters",
  "/front-load-dumpsters": "/front-load",
  "/front-load-dumpster": "/front-load",
  "/construction-waste-management": "/contractor-dumpster-rentals",
  "/our-services": "/",
  "/yws-services": "/",
  "/service-area": "/service-areas",
  "/prescott-area": "/service-areas/prescott",
  "/prescott-valley-area": "/service-areas/prescott-valley",
  "/chino-valley-area": "/service-areas/chino-valley",
  "/paulden-area": "/service-areas/paulden",
  "/williamson-valley-area": "/service-areas/williamson-valley",
  "/dewey-area": "/service-areas/dewey",
  "/humboldt-area": "/service-areas/humboldt",
  "/cordes-junction-area": "/service-areas/cordes-junction",
  "/about-us": "/about",
  "/about-us-2": "/about",
  "/contact-us": "/contact",
  "/contact-us-qr-code": "/contact",
  "/testimonials": "/",
  "/blog": "/resources",
  "/2-yard-commercial-dumpster": "/front-load/commercial",
  "/3-yard-commercial-dumpster": "/front-load/commercial",
  "/4-yard-commercial-dumpster": "/front-load/commercial",
  "/6-yard-commercial-dumpster": "/front-load/commercial",
  "/8-yard-commercial-dumpster": "/front-load/commercial",
  "/https-yavapaiwastesolutions-com-privacy-policy": "/",
  "/how-i-got-into-the-trash-business": "/resources/how-i-got-into-the-trash-business",
  "/why-customer-service-is-the-heart-of-yavapai-waste-solutions": "/resources/why-customer-service-is-the-heart-of-yavapai-waste-solutions",
  "/choosing-the-right-roll-off-container-for-your-northern-arizona-project": "/resources/choosing-the-right-roll-off-container-for-your-northern-arizona-project",
  "/front-load-services-a-game-changer-for-tri-city-businesses": "/resources/front-load-services-a-game-changer-for-tri-city-businesses",
  "/front-load-vs-roll-off-which-dumpster-is-right-for-your-prescott-business": "/resources/front-load-vs-roll-off-which-dumpster-is-right-for-your-prescott-business",
  "/prescott-firewise-cleanup-how-to-use-defensible-space-bins-the-right-way": "/resources/prescott-firewise-cleanup-how-to-use-defensible-space-bins-the-right-way",
  "/top-5-dumpster-sizes-you-need-for-a-prescott-home-renovation": "/resources/top-5-dumpster-sizes-you-need-for-a-prescott-home-renovation",
};
